<template>
    <div class="class-item" :style="{ backgroundColor: course.color }" @click="openClass(course.id)">
        <h3>{{course.title}}</h3>
        <p class="time">{{ course.start | formatTime }} - {{ course.end | formatTime }}</p>
        <p class="trainer">
            <v-avatar size="23"><img :src="course.trainer.profile_photo_url+'?w=23'" alt=""></v-avatar>
            <span>{{ course.trainer.full_name }}</span>
        </p>
        <p class="booked">{{ $page.props.lang.booked || "Booked" }}: {{ course.booked_seats }}/{{ course.max_seats }}</p>
    </div>
</template>

<script>

import EventBus from '../../../../eventbus';

export default {
    props: {
        course: Object
    },
    data(){
        return{
            showDetailsModal: false
        }
    },
    methods: {
        openClass() {
            EventBus.$emit('SHOW_COURSE_MODAL', this.course);
        }
    }
}
</script>
<style scoped>
.class-item{
    cursor: pointer;
    margin-bottom: 10px;
    color: #fff;
}
</style>